import React, { useEffect, useState } from "react";
import { Link } from "~/components/Elements";
import "./Volby2023.css";
const urlAllInfo = "https://www.teraz.sk/parlamentne-volby-2023";
const urlCandidatesInfo = "https://www.teraz.sk/kandidatne-listiny-volbynrsr23";
const urlElectionResults = "https://www.teraz.sk/volby-2023";

const HeaderBanner = (props) => {
  
  var end = new Date('09/30/2023 07:00 AM');
  const [showInfo, setShowInfo] = useState(false);
  const [showCounter, setShowCounter] = useState(false);  
  var timer;

  useEffect(() => {   
    const now = new Date();
    const startElections = new Date('09/30/2023 07:00 AM');
    const endElections = new Date('09/30/2023 10:00 PM');
    if(Date.parse(now) > Date.parse(startElections)){      
        if (timer) {
          clearInterval(timer);                    
        }        
        end = new Date('09/30/2023 10:00 PM');
        setShowInfo(true);
    }
  
    var _second = 1000;
    var _minute = _second * 60;
    var _hour = _minute * 60;
    var _day = _hour * 24;    
    function showRemaining() {
        var _now = new Date();
        var distance = end - _now;
        if (distance < 0) {
            clearInterval(timer);
            return;
        }
        // var days = Math.floor(distance / _day).toString();
        var hours = Math.floor((distance % _day) / _hour).toString();
        var minutes = Math.floor((distance % _hour) / _minute).toString();
        var seconds = Math.floor((distance % _minute) / _second).toString();
        if (typeof document !== 'undefined' && document.querySelector('.hours') != null) {
          // document.querySelector('.days').innerHTML = ("0" + days).slice(-2);
          document.querySelector('.hours').innerHTML = ("0" + hours).slice(-2);
          document.querySelector('.minutes').innerHTML = ("0" + minutes).slice(-2);
          document.querySelector('.seconds').innerHTML = ("0" + seconds).slice(-2);
      }      
    }

    // timer = setInterval(showRemaining, 1000);
    // showCounter = true;
    setShowCounter(true);



  },[]);

  return (
    <div>
      <div className="bannerBase referendum-fullWidth">
            <div className="bannerBase-inner referendum-inner elections">
              <div className="countdownWrapper-text">
                {showInfo &&
                  <div className="countdownInfo">Do uzavretia volebných miestností ostáva:</div>
                }
                <div className="bannerCountdownWrapper" style={{ visibility: showCounter ? 'visible' : 'hidden' }}>
                  {/* <div>
                    <div className="label">Dni</div>
                    <div className="days val">&nbsp;</div>
                  </div>                  
                  <div className="sep">:</div> */}
                  <div>
                    <div className="label">Hodiny</div>
                    <div className="hours val">00</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Minúty</div>
                    <div className="minutes val">00</div>
                  </div>                  
                  <div className="sep">:</div>
                  <div>
                    <div className="label">Sekundy</div>
                    <div className="seconds val">00</div>
                  </div>                  
                </div>
              </div>                

                <div className="bannerBase-elections-title-wrapper">
                  <span>Parlamentné voľby 2023</span>
                </div>

                <div className="actions">
                  <Link to={urlElectionResults}>
                    <div className="bannerBase-referendum-btn red-border no-margin">Neoficiálne volebné výsledky</div>
                  </Link>
                  <Link to={urlCandidatesInfo}>
                    <div className="bannerBase-referendum-btn no-margin">Kandidátne listiny politických subjektov</div>
                  </Link>
                  <Link to={urlAllInfo}>
                    <div className="bannerBase-referendum-btn no-margin">Všetko o voľbách</div>
                  </Link>
                </div>
                

                <Link className="fullAreaBtn" to={urlAllInfo}><div className="bannerBase-referendum-fullBtnArea"></div></Link>                
            </div>
      </div>
    </div>
  );
};

export default HeaderBanner;
